angular.module('zc.zenclerkS')
  .controller('ZcsCampaignEditModalExitController', ZcsCampaignEditModalExitController);

ZcsCampaignEditModalExitController.$inject = ['$state', '$uibModalInstance', 'ZcsCampaign', 'campaign', 'project'];
function ZcsCampaignEditModalExitController($state, $uibModalInstance, ZcsCampaign, campaign, project) {
  /* Init */
  const vm = this;

  /* Variables */
  vm.project = project;
  vm.campaign = campaign;
  vm.isNewCampaign = isNewCampaign;
  vm.save = save;
  vm.close = close;
  vm.exitWithoutSaving = exitWithoutSaving;

  /* Functions */
  function isNewCampaign() {
    return vm.campaign.id === 'new';
  }

  function exitWithoutSaving() {
    exit('zenclerkS.project.campaigns');
  }

  function save() {
    ZcsCampaign.save(vm.campaign, vm.project)
      .then(res => {
        if(!vm.campaign.id || vm.campaign.id === 'new') {
          exit('zenclerkS.project.campaigns.draft');
        } else if(vm.campaign.current_status === 'incomplete') {
          exit('zenclerkS.project.campaigns.draft');
        } else {
          exit('zenclerkS.project.campaigns.active');
        }
      });
  }

  function exit(route) {
    $state.go(
      route,
      { apikey: vm.project.apikey },
      // reload to refresh possibly edited project object.
      // the object needs to be refreshed because it would otherwise
      // cause errors when saving it in other views
      { reload: true }
    );
    close();
  }

  function close() {
    $uibModalInstance.close();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_exit.controller.js